<template>
  <div class="metrics-table">
    <v-row align="center">
      <v-col>
        <div class="caption grey--text text-uppercase font-weight-black">
          Ingresos totales
        </div>
        <br />
        <div>
          <span class="display-1 font-weight-black">
            {{ formatPrice(totalRevenue) }}
          </span>
          <percentage-increase-or-decrease
            :quantity1="totalRevenue"
            :quantity2="totalRevenueLastYear"
          ></percentage-increase-or-decrease>
          <br />
          <strong>
            Período anterior: {{ formatPrice(totalRevenueLastYear) }}
          </strong>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Métrica</th>
            <th class="text-left">
              {{ dayFormat2(labelDataset1) }} - {{ dayFormat2(labelDataset1) }}
            </th>
            <th class="text-left">
              {{ dayFormat2(labelDataset2) }} - {{ dayFormat2(labelDataset2) }}
            </th>
            <th class="text-left">
              <v-icon class="increment-icon">mdi-triangle</v-icon>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-left">Pagos con Tarjeta</td>
            <td class="text-left">
              {{ formatPrice(creditCardAmount) }}
            </td>
            <td class="text-left">
              {{ formatPrice(creditCardAmountLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="creditCardAmount"
                :quantity2="creditCardAmountLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Pagos Efectivo</td>
            <td class="text-left">
              {{ formatPrice(efectivoAmount) }}
            </td>
            <td class="text-left">
              {{ formatPrice(efectivoAmountLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="efectivoAmount"
                :quantity2="efectivoAmountLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Pagos con Datáfono</td>
            <td class="text-left">
              {{ formatPrice(datafonoAmount) }}
            </td>
            <td class="text-left">
              {{ formatPrice(datafonoAmountLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="datafonoAmount"
                :quantity2="datafonoAmountLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Pagos con Google Pay</td>
            <td class="text-left">
              {{ formatPrice(googlePayAmount) }}
            </td>
            <td class="text-left">
              {{ formatPrice(googlePayAmountLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="googlePayAmount"
                :quantity2="googlePayAmountLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Pagos con Apple Pay</td>
            <td class="text-left">
              {{ formatPrice(applePayAmount) }}
            </td>
            <td class="text-left">
              {{ formatPrice(applePayAmountLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="applePayAmount"
                :quantity2="applePayAmountLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
          <tr>
            <td class="text-left">Pagos con Bizum</td>
            <td class="text-left">
              {{ formatPrice(bizumAmount) }}
            </td>
            <td class="text-left">
              {{ formatPrice(bizumAmountLastYear) }}
            </td>
            <td class="text-left increment-decrement-icon">
              <percentage-increase-or-decrease
                :quantity1="bizumAmount"
                :quantity2="bizumAmountLastYear"
              ></percentage-increase-or-decrease>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import PercentageIncreaseOrDecrease from "@/components/admin/dashboard/PercentageIncreaseOrDecrease";
export default {
  name: "LastClosureTable",
  components: { PercentageIncreaseOrDecrease },
  props: {
    lastZclosure: {
      type: Object,
      default: null
    },
    lastYearZclosure: {
      type: Array,
      default: null
    },
    labelDataset1: {
      type: Date,
      default: null
    },
    labelDataset2: {
      type: Date,
      default: null
    }
  },
  computed: {
    totalRevenue() {
      let total = 0;
      total +=
        Number(this.lastZclosure.total_invoiced_on_credit_card) +
        Number(this.lastZclosure.total_invoiced_in_cash) +
        Number(this.lastZclosure.total_invoiced_in_datafono) +
        Number(this.lastZclosure.total_invoiced_in_google_pay) +
        Number(this.lastZclosure.total_invoiced_in_apple_pay) +
        Number(this.lastZclosure.total_invoiced_in_bizum);
      return total || 0;
    },
    totalRevenueLastYear() {
      let total = 0;
      total +=
        Number(this.lastYearZclosure[0]?.total_invoiced_on_credit_card) +
        Number(this.lastYearZclosure[0]?.total_invoiced_in_cash) +
        Number(this.lastYearZclosure[0]?.total_invoiced_in_datafono) +
        Number(this.lastYearZclosure[0]?.total_invoiced_in_google_pay) +
        Number(this.lastYearZclosure[0]?.total_invoiced_in_apple_pay) +
        Number(this.lastYearZclosure[0]?.total_invoiced_in_bizum);
      return total || 0;
    },
    googlePayAmount() {
      return this.lastZclosure.total_invoiced_in_google_pay || 0;
    },
    googlePayAmountLastYear() {
      return this.lastYearZclosure[0]?.total_invoiced_in_google_pay || 0;
    },
    applePayAmount() {
      return this.lastZclosure.total_invoiced_in_apple_pay || 0;
    },
    applePayAmountLastYear() {
      return this.lastYearZclosure[0]?.total_invoiced_in_apple_pay || 0;
    },
    efectivoAmount() {
      return this.lastZclosure.total_invoiced_in_cash || 0;
    },
    efectivoAmountLastYear() {
      return this.lastYearZclosure[0]?.total_invoiced_in_cash || 0;
    },
    datafonoAmount() {
      return this.lastZclosure.total_invoiced_in_datafono || 0;
    },
    datafonoAmountLastYear() {
      return this.lastYearZclosure[0]?.total_invoiced_in_datafono || 0;
    },
    creditCardAmount() {
      return this.lastZclosure.total_invoiced_on_credit_card || 0;
    },
    creditCardAmountLastYear() {
      return this.lastYearZclosure[0]?.total_invoiced_on_credit_card || 0;
    },
    bizumAmount() {
      return this.lastZclosure.total_invoiced_in_bizum || 0;
    },
    bizumAmountLastYear() {
      return this.lastYearZclosure[0]?.total_invoiced_in_bizum || 0;
    }
  }
};
</script>
